import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router';
import {getGuestId, getLoggedUserId} from '~/common/fabric/User/reducers/user';

export const useCurrentGuestId = () => {
  const gid = useSelector(getGuestId);
  const userId = useSelector(getLoggedUserId);
  const location = useLocation();
  const [guestId, setGuestId] = useState<string>(gid || window.guest_id);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const gidFromParams = params.get('gid');
    if (gidFromParams) {
      setGuestId(gidFromParams);
    }
  }, [location.search]);

  return {guestId, userId};
};
